import React from 'react';

import { BANNER_POSITION, bannerPositions } from '../../constants/banners';

const BannerAction = () => <div id={bannerPositions[BANNER_POSITION.STATIC.ACTION].id} />;

export default BannerAction;
